import React, { useEffect, useState } from 'react'
import { useServerAPI } from '../Session';
import { Paper, Typography } from '@mui/material';
import { DataGridPro as DataGrid, GridActionsCellItem, GridColDef, GridFilterModel, GridPaginationModel, GridSortModel } from '@mui/x-data-grid-pro';
import EditIcon from '@mui/icons-material/Edit';
import SecurityIcon from '@mui/icons-material/Security';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { useAuth } from '../Authentication';
import { CommonToolbar } from '../components/CommonToolbar';

function AircraftListPage() {

    const [loading,setLoading] = useState(false);
    const [customers, setCustomers] = useState<any[]>();
    const [customerCount, setCustomerCount] = useState(-1);
    const [paginationModel, setPaginationModel] = React.useState<GridPaginationModel>({
        pageSize: 25,
        page: 0,
    });
    const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
        items: []
    })
    const [sortModel, setSortModel] = React.useState<GridSortModel>();
    const { userData } = useAuth();
    
    const server = useServerAPI();
    const percentFormmater = new Intl.NumberFormat('en-CA', { style: 'percent' })
    // valueFormatter: (v) => percentFormmater.format(v),
    
    const columns: GridColDef[] = [
        {
            field: 'data.Customer_TAX_status',
            valueGetter: (v, r) => {
                return r?.data.Customer_TAX_status
            },
            headerName: 'ID',
            width: 90
        },
        {
            field: 'data.Customer_Type',
            valueGetter: (v, r: any) => r?.data.Customer_Type,
            headerName: 'Customer_Type',
            flex: 2
            //   editable: true,
        },
        {
            field: 'data.effective',
            valueGetter: (v, r: any) => r?.data.effective.split(" ")[0],
            headerName: 'Effective',
            width: 150,
            //   editable: true,
        },
        {
            field: 'data.GST',
            valueGetter: (v, r: any) => parseFloat(r?.data.GST)/100,
            valueFormatter: (v) => percentFormmater.format(v),
            headerName: 'GST',
            width: 60,
            // flex: 1
            //   editable: true,
        },
        {
            field: 'data.QST',
            valueGetter: (v, r: any) => parseFloat(r?.data.QST?? "0")/100,
            valueFormatter: (v) => percentFormmater.format(v),
            headerName: 'QST',
            width: 60,
        },
        {
            field: 'data.HST_NS',
            valueGetter: (v, r: any) => parseFloat(r?.data.HST_NS?? "0")/100,
            valueFormatter: (v) => percentFormmater.format(v),
            headerName: 'HST_NS',
            width: 90,
        },
        {
            field: 'data.HST_NB',
            valueGetter: (v, r: any) => parseFloat(r?.data.HST_NB?? "0")/100,
            valueFormatter: (v) => percentFormmater.format(v),
            headerName: 'HST_NB',
            width: 90,
        },
        {
            field: 'data.HST_NL',
            valueGetter: (v, r: any) => parseFloat(r?.data.HST_NL?? "0")/100,
            valueFormatter: (v) => percentFormmater.format(v),
            headerName: 'HST_NL',
            width: 90,
        },
        {
            field: 'data.HST_ON',
            valueGetter: (v, r: any) => parseFloat(r?.data.HST_ON ?? "0")/100,
            valueFormatter: (v) => percentFormmater.format(v),
            headerName: 'HST_ON',
            width: 90,
        },
        {
            field: 'data.HST_PE',
            valueGetter: (v, r: any) => parseFloat(r?.data.HST_PE?? "0")/100,
            valueFormatter: (v) => percentFormmater.format(v),
            headerName: 'HST_PE',
            width: 90,
        },
        {
            field: 'actions',
            type: 'actions',
            width: 80,
            getActions: (params) => [
                <GridActionsCellItem
                    icon={<EditIcon />}
                    label="Edit"
                    // onClick={handleEditCustomer(params.row.entityId)}
                />,
                <GridActionsCellItem
                    icon={<SecurityIcon />}
                    label="Other Action"
                    // onClick={toggleAdmin(params.id)}
                    showInMenu
                />,
                <GridActionsCellItem
                    icon={<FileCopyIcon />}
                    label="Other Other Action"
                    // onClick={duplicateUser(params.id)}
                    showInMenu
                />,
            ],
        },
    ];

    const handleFilterModelChange = (filterModel: GridFilterModel) => {
        console.debug(`filterModel`, filterModel);
        setCustomerCount(-1);
        setFilterModel(filterModel);
    }
    const handleSortModelChange = (newsortModel: GridSortModel) => {
        console.debug(`filterModel`, newsortModel);
        setSortModel(newsortModel);
    }

    useEffect(() => {
        if (customerCount === -1) {
            server.countTaxe(filterToSearchCriteria(filterModel)).then(r => {
                if (typeof r === 'number') {
                    setCustomerCount(r);
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterModel]);

    useEffect(() => {
        if (!loading) {
            setLoading(true);
            server.listTaxe(paginationModel.pageSize, paginationModel.page + 1, filterToSearchCriteria(filterModel), sortToSortCriteria(sortModel)).then(r => {
                if (r) {
                    if (Array.isArray(r)) {
                        setCustomers(r);
                        console.log(`Got customer list ${r.length}`);
                    }
                }
                setLoading(false);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel, filterModel, sortModel])

    React.useEffect(()=>{
        if (userData?.authPayload?.Customer_Number) {
            
        }
    },[userData])

    const filterToSearchCriteria = (filters: GridFilterModel) => {
        var searchCriteria: { [prop: string]: any } = {};
        for (const filter of filters.items) {
            switch (filter.operator) {
                case "contains":
                    searchCriteria[filter.field] = { "$regex": `${filter.value}` };
                    break;
                case "equals":
                    searchCriteria[filter.field] = filter.value;
                    break;
                case "startsWith":
                    searchCriteria[filter.field] = { "$regex": `^${filter.value}` };
                    break;
                case "endsWith":
                    searchCriteria[filter.field] = { "$regex": `${filter.value}$` };
                    break;
                case "isEmpty":
                    searchCriteria[filter.field] = { "$exists": false };
                    break;
                case "isNotEmpty":
                    searchCriteria[filter.field] = { "$exists": true };
                    break;
                case "isAnyOf":
                    searchCriteria[filter.field] = { "$in": filter.value };
                    break;

                default:
                    break;
            }
        }
        if (userData?.authPayload?.Customer_Number) {
            // if the user has a set customer then force it.
            searchCriteria["data.Customer_Number"] = userData?.authPayload?.Customer_Number;   
        }
        return searchCriteria;
    }

    const sortToSortCriteria = (sortList?: GridSortModel) => {
        var sortCriteria: { [prop: string]: any } = {};
        if (sortList) {
            for (const sort of sortList) {
                sortCriteria[sort.field] = sort.sort === 'asc' ? 1 : -1;
            }
        }
        return sortCriteria;
    }

    return (
        <Paper elevation={1} sx={{ margin: '20px' }}>
            <Typography variant='h5'>Tax Status</Typography>            
            <DataGrid
                slots={{ toolbar: CommonToolbar }}
                loading={loading}
                pagination
                rows={customers ?? []}
                getRowId={(r) => r.entityId}
                columns={columns}
                rowCount={customerCount}
                paginationMode='server'
                onFilterModelChange={handleFilterModelChange}
                filterModel={filterModel}
                filterMode='server'
                onPaginationModelChange={setPaginationModel}
                paginationModel={paginationModel}
                sortingMode='server'
                sortModel={sortModel}
                onSortModelChange={handleSortModelChange}
                // autoPageSize
                autoHeight
                // pageSizeOptions={[5,10,20]}
            />
        </Paper>
    )
}

export default AircraftListPage 